<template>
  <div class="dropdown-menu-element pointer version-selector-menu-element-wrapper">
    <div class="version-selector-menu-element">
      <div class="version-selector-menu-element__title">
        <span><slot name="title" /></span>
        <slot name="badges" />
      </div>
      <div class="version-selector-menu-element__description">
        <slot name="description" />
      </div>
      <div v-if="$slots.default" class="version-selector-menu-element__common">
        <slot />
      </div>
    </div>
    <div v-if="$slots['delete-icon']" class="version-selector-menu-element__delete-icon">
      <slot name="delete-icon" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'VersionSelectorMenuElement',
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .version-selector-menu-element-wrapper {
    display: flex;
    flex-direction: row;
    align-items: flex-start;

    .version-selector-menu-element {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      &__title {
        color: $grey900;
        font-weight: 700;
        font-size: 14px;
        flex: 1;
        flex-direction: row;
        display: flex;
        gap: 6px;
      }

      &__description {
        color: $grey600;
        font-size: 14px;
        font-weight: 500;
      }

      &__common {
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: flex-start;
        align-items: center;
      }

      &__delete-icon {
        height: 100%;
      }
    }
  }
</style>
